import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Seo from './Seo';
import { useSiteData } from '../context/SiteDataContext';
import { Megaphone } from 'lucide-react';

export default function PublicLayout() {
  const { settings } = useSiteData();
  return (
    <div className="flex min-h-screen flex-col">
      <Seo />
      {settings.announcementEnabled && settings.announcementText && (
        <div className="relative z-50 flex items-center justify-center gap-2 bg-gradient-to-r from-accent-600 to-sky-500 px-4 py-2 text-center text-sm font-semibold text-white">
          <Megaphone size={16} className="shrink-0" />
          {settings.announcementText}
        </div>
      )}
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
